<template>
  <svg class="icon"
       width="25"
       height="17"
       viewBox="0 0 25 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M12.5 0C5.14781 0 0 8.0884 0 8.0884C0 8.0884 3.74986 16.1768 12.5 16.1768C21.3232 16.1768 25 8.0884 25 8.0884C25 8.0884 19.9267 0 12.5 0ZM12.5 13.2348C9.63246 13.2348 7.35361 10.9559 7.35361 8.0884C7.35361 5.22086 9.63246 2.94201 12.5 2.94201C15.3675 2.94201 17.6464 5.22086 17.6464 8.0884C17.6464 10.9559 15.3675 13.2348 12.5 13.2348Z" />
    <path fill="currentColor" d="M14.7055 8.08764C14.7055 9.30633 13.7184 10.2934 12.4997 10.2934C11.281 10.2934 10.2939 9.30633 10.2939 8.08764C10.2939 6.86894 11.281 5.88184 12.4997 5.88184C13.7184 5.88184 14.7055 6.86894 14.7055 8.08764Z" />
  </svg>
</template>

<script>
export default {
  name: 'View',
};
</script>
